import '../../styles/speaker.css';
import logo from '../../assets/images/Q3logotext.png';
import jonathanmartin from "../../assets/images/speakers/jonathanmartin.jpeg";

function JonathanM() {
  return (
    <>
    <div class="header">
      <div class="header-content">
        <div class="left">
          <div class="header-box">
            <h1 className="title">Q<sup>3</sup> Initiative: QREATE @ UMD</h1>
          </div>
          <p>September 12, 2025 - September 13, 2025</p>
          <p>University of Maryland, College Park</p>
          <p>Stamp Student Union: Hoff Theatre</p>
        </div>
        <div className="right">
          <img src={logo} className="logo" alt="Q^3 Logo" />
        </div>
      </div>
    </div>
    <div className="speaker-box">
      <div className="speaker-photo">
         <img src={jonathanmartin} alt="Jonathan D. Martin" className="speakerspic"/>
      </div>
      <div className="speaker-content">
      <h1>Jonathan David Martin</h1>
      <h2>Creative Director, Producer, & Researcher</h2>
    </div>  
    </div>
    <div className="speaker-content">
      <p className="p">
          Jonathan David Martin is a researcher, creative director, and producer working at the intersection of immersive technology and live performance.  His work explores the development of new narrative and production approaches to content creation across a range of mediums. 
At UMD he has been part of the Immersive Media Design faculty since 2021. His research at UMD includes the interactive dance, AI, and robotics project, DANCE^2 (Dance Squared), Quantum Choreographies, and the forthcoming AI art exhibit Future Frames. He is the founding Program Manager of the New Works Incubator, a summer program that supports a range of student immersive media projects from across the UMD community.  
His professional work has won grants and competitions from Meta (Oculus Launch Pad grantee), Niantic (Best Shared AR experience), and the US State Department. He is a pioneer in VR performance technique and was a puppeteer in the original Broadway casts of War Horse and Life of Pi. Annenberg Arts Fellow. 

      </p>  
    </div>
    </>
  );
}

export default JonathanM;